<template>
  <router-link :to="route" class="redirect-block">
    <div class="redirect-block__image">
      <slot></slot>
    </div>
    <div class="redirect-block__text-wrapper">
      <div class="redirect-block__title">{{ title }}</div>
      <div class="redirect-block__subtitle">
        {{ subTitle }}
      </div>
    </div>
    <div class="redirect-block--icon ml-auto">
      <v-icon color="primary">mdi-chevron-right</v-icon>
    </div>
  </router-link>
</template>

<script>
  export default {
    name: "RedirectBlock",
    props: {
      title: {
        type: String,
        default: "",
      },
      subTitle: {
        type: String,
        default: "",
      },
      route: {
        required: true,
        type: Object,
        default: () => {},
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/functions.scss";
  @import "../../@core/preset/preset/typography/index.scss";
  .redirect-block {
    padding: 24px;
    background-color: get-color("element-bg-100");
    border-radius: 6px;
    box-shadow: 0px 2px 5px rgba(69, 64, 78, 0.05);
    display: flex;
    align-items: center;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      background-color: get-color("primary-10-hover");
    }

    &__image {
      margin-right: 17px;
    }
    &__text_wrapper {
      display: flex;
      flex-direction: column;
    }
    &__title {
      @include heading-4();
      color: get-color("headline");
    }
    &__subtitle {
      @include text-subtitle-2();
      color: get-color("subtitle");
    }
  }
</style>
